import styled from "styled-components"

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  font-family: "Calsans", sans-serif;
  margin: 4rem 0 4rem;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
